import { render } from "./DemandeInscription.vue?vue&type=template&id=13e96b00&scoped=true&ts=true"
import script from "./DemandeInscription.vue?vue&type=script&lang=ts"
export * from "./DemandeInscription.vue?vue&type=script&lang=ts"

import "./DemandeInscription.vue?vue&type=style&index=0&id=13e96b00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e96b00"]])

export default __exports__